import { Component, Input } from '@angular/core';
import { IFilterOptions } from './filter.model';

@Component({
	selector: 'jhi-filter',
	templateUrl: './filter.component.html',
	standalone: false,
})
export class FilterComponent {
	@Input() filters!: IFilterOptions;

	clearAllFilters(): void {
		this.filters.clear();
	}

	clearFilter(filterName: string, value: string): void {
		this.filters.removeFilter(filterName, value);
	}
}
